"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubblesApplicationService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const bubble_1 = require("./bubble");
class BubblesApplicationService {
    constructor(bubblesRepo) {
        this.bubblesRepo = bubblesRepo;
    }
    findBubbles(tenantId) {
        return this.bubblesRepo.getForTenant(tenantId);
    }
    childrenForBubble(tenantId, bubbleName, weekIdentifier, getManyChildrenByIds) {
        return this.bubblesRepo.getForTenant(tenantId).pipe(operators_1.flatMap((bubbles) => {
            const bubble = bubbles.findBubbleByName(bubbleName);
            if (bubble == null) {
                return rxjs_1.of([]);
            }
            return getManyChildrenByIds(bubble.childIdsInBubble(weekIdentifier.value));
        }));
    }
    bubbleForChild(tenantId, weekIdentifier, childId) {
        return this.bubblesRepo
            .getForTenant(tenantId)
            .pipe(operators_1.map((bubbles) => bubbles.findBubbleChildIsAssignedTo(weekIdentifier.value, childId)));
    }
    async addChildToBubble(tenantId, bubbleName, weekIdentifier, childId) {
        const bubbles = await this.findBubbles(tenantId).pipe(operators_1.first()).toPromise();
        if (!bubbles.bubbleWithNameExists(bubbleName)) {
            return {
                status: 'rejected',
                reason: 'Can not add child to bubble: bubble with name does not exist',
            };
        }
        if (bubbles.childIsAssignedABubble(weekIdentifier.value, childId)) {
            return {
                status: 'rejected',
                reason: 'Child is already assigned to a bubble',
            };
        }
        await this.bubblesRepo.put(bubbles.withChildAddedToBubble(bubbleName, weekIdentifier.value, childId));
        return { status: 'accepted' };
    }
    async removeChildFromBubble(tenantId, bubbleName, weekIdentifier, childId) {
        var _a;
        const bubbles = await this.findBubbles(tenantId).pipe(operators_1.first()).toPromise();
        if (!bubbles.bubbleWithNameExists(bubbleName)) {
            return {
                status: 'rejected',
                reason: 'Can not remove child from bubble: bubble with name does not exist',
            };
        }
        if (((_a = bubbles
            .findBubbleByName(bubbleName)) === null || _a === void 0 ? void 0 : _a.includesChild(weekIdentifier.value, childId)) !== true) {
            return {
                status: 'rejected',
                reason: 'Can not remove child from bubble: child is not in bubble',
            };
        }
        await this.bubblesRepo.put(bubbles.withChildRemovedFromBubble(bubbleName, weekIdentifier.value, childId));
        return { status: 'accepted' };
    }
    async createBubble(tenantId, bubbleName, maxChildren) {
        const bubbles = await this.findBubbles(tenantId).pipe(operators_1.first()).toPromise();
        if (bubbles.bubbleWithNameExists(bubbleName)) {
            return { status: 'rejected', reason: 'Bubble with name exists' };
        }
        await this.bubblesRepo.put(bubbles.withBubbleAdded(bubble_1.Bubble.create(bubbleName, maxChildren)));
        return { status: 'accepted' };
    }
    async deleteBubble(tenantId, bubbleName) {
        const bubbles = await this.findBubbles(tenantId).pipe(operators_1.first()).toPromise();
        const bubble = bubbles.findBubbleByName(bubbleName);
        if (bubble == null) {
            return {
                status: 'rejected',
                reason: 'Bubble not found; could not remove it',
            };
        }
        if (bubble.numChildrenTotal !== 0) {
            return {
                status: 'rejected',
                reason: 'Could not remove bubble as there are children attached to it',
            };
        }
        await this.bubblesRepo.put(bubbles.withBubbleRemoved(bubbleName));
        return { status: 'accepted' };
    }
    async renameBubble(tenantId, oldBubbleName, newBubbleName) {
        const bubbles = await this.findBubbles(tenantId).pipe(operators_1.first()).toPromise();
        if (bubbles.bubbleWithNameExists(newBubbleName)) {
            return { status: 'rejected', reason: 'Bubble with name already exists' };
        }
        if (!bubbles.bubbleWithNameExists(oldBubbleName)) {
            return {
                status: 'rejected',
                reason: 'Bubble with name does not exist, can not rename',
            };
        }
        await this.bubblesRepo.put(bubbles.withRenamedBubble(oldBubbleName, newBubbleName));
        return { status: 'accepted' };
    }
    async setBubbleMaxChildren(tenantId, bubbleName, newMaxChildren) {
        const bubbles = await this.findBubbles(tenantId).pipe(operators_1.first()).toPromise();
        if (!bubbles.bubbleWithNameExists(bubbleName)) {
            return { status: 'rejected', reason: 'Bubble with name not found' };
        }
        await this.bubblesRepo.put(bubbles.withChangedMaxChildrenForBubble(bubbleName, newMaxChildren));
        return { status: 'accepted' };
    }
}
exports.BubblesApplicationService = BubblesApplicationService;
//# sourceMappingURL=bubbles.application-service.js.map